import { forwardRef } from "react";
import { TextInput } from "../inputs";
import { jsx } from "react/jsx-runtime";
const NameInput = forwardRef(
  ({
    analyticsName,
    invalidNameError = "Please enter your full name.",
    title = "Full name",
    size = "medium",
    autoComplete = "name",
    ariaLabelledBy,
    ...props
  }, ref) => /* @__PURE__ */ jsx(
    TextInput,
    {
      ref,
      id: "name",
      analyticsName: `${analyticsName}-name`,
      size,
      autoComplete,
      errorText: props.errorText || invalidNameError,
      ...ariaLabelledBy ? { ariaLabelledBy } : { title },
      ...props
    }
  )
);
NameInput.displayName = "NameInput";
export {
  NameInput
};
